import { atom } from 'recoil'

export const modalOnSaveChangeThemeState = atom({
  key: 'modalOnSaveChangeThemeState',
  default: false
})
